import React from "react";

import { Button, SpinnerLoader } from "components";
import { useUnlinkFusionAuthUserMutation } from "queries";

import styles from "./ssoIdUsersModal.module.scss";

type LinkedUsersTableProps = {
	userId: string;
	userFullName?: string;
	setIsUserLinked: Function;
	refetchUser?: Function;
	email?: string;
};

const LinkedUsersTable = ({
	userId,
	userFullName,
	setIsUserLinked,
	refetchUser,
	email,
}: LinkedUsersTableProps) => {
	const { mutate: unlinkUser, isLoading: isLoadingUnlinkUser } =
		useUnlinkFusionAuthUserMutation({
			userId,
			onSuccess: () => {
				setIsUserLinked(false);
				refetchUser?.();
			},
		});

	return (
		<ul className={styles.ssoIdUsersList}>
			<li className={styles.ssoIdUsersItem}>
				<div>
					<span className={styles.label}>{email || ""}</span> (
					{userFullName || ""})
				</div>
				<div>
					{isLoadingUnlinkUser ? (
						<div className={styles.spinnerWrapper}>
							<SpinnerLoader />
						</div>
					) : (
						<div className="d-flex align-items-center">
							<div className="vl"></div>
							<Button
								onClick={unlinkUser}
								variant="secondary"
								value="Remove link"
								minWidth="120px"
							/>
						</div>
					)}
				</div>
			</li>
		</ul>
	);
};

export default LinkedUsersTable;
